import { render, staticRenderFns } from "./MonthlyArea.vue?vue&type=template&id=6a0997fa"
import script from "./MonthlyArea.vue?vue&type=script&lang=js"
export * from "./MonthlyArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports